import React from "react";
import useAuth from "../hooks/useAuth.js";
import { useState } from "react";
import { Link } from "react-router-dom";

import companyLogo from "../assets/images/logo.svg";
// import Banner from "../components/Banner.js";

const Navbar = ({ hideAuthButtons = false }) => {
  const { isAuthenticated } = useAuth();
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <>
    {/* <Banner /> */}
    <nav className="relative container mx-auto p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <img src={companyLogo} alt="" className="mx-auto w-24 h-auto" />
        </div>
        <div className="hidden space-x-6 md:flex">
          <Link to="/" className="hover:text-gray-600">
            Home
          </Link>
          <Link to="/about" className="hover:text-gray-600">
            About
          </Link>
          <Link to="/pricing" className="hover:text-gray-600">
            Pricing
          </Link>
          <Link to="/contact" className="hover:text-gray-600">
            Contact
          </Link>
        </div>
        {!hideAuthButtons && (
          <div className="flex items-center space-x-2">
            {!isAuthenticated ? (
              <>
                <Link
                  to="/login"
                  className="hidden p-3 px-6 pt-3 text-gray-800 bg-transparent rounded-full baseline hover:text-gray-600 md:block"
                >
                  Sign In
                </Link>
                <Link
                  to="/register"
                  className="hidden p-3 px-6 pt-3 text-white bg-gray-600 rounded-full baseline hover:bg-gray-700 md:block active:bg-gray-800 transition-colors"
                >
                  Try for Free
                </Link>
              </>
            ) : (
              <Link
                to="/app/dashboard"
                className="hidden p-3 px-6 pt-3 text-white bg-gray-600 rounded-full hover:bg-gray-700 md:block"
              >
                Return to Dashboard
              </Link>
            )}
          </div>
        )}

        {/* Hamburger Icon */}
        <button
          className={
            toggleMenu
              ? "open block hamburger md:hidden focus:outline-none"
              : "block hamburger md:hidden focus:outline-none"
          }
          onClick={() => setToggleMenu(!toggleMenu)}
        >
          <span className="hamburger-top"></span>
          <span className="hamburger-middle"></span>
          <span className="hamburger-bottom"></span>
        </button>
      </div>
      {toggleMenu && (
        <div className="md:hidden bg-white pt-2 pb-4 px-4 shadow-md">
          <div className="flex flex-col space-y-4">
            <Link
              to="/"
              className="py-2 text-gray-700 hover:text-gray-600 border-b border-gray-100"
              onClick={() => setToggleMenu(false)}
            >
              Home
            </Link>
            <Link
              to="/about"
              className="py-2 text-gray-700 hover:text-gray-600 border-b border-gray-100"
              onClick={() => setToggleMenu(false)}
            >
              About
            </Link>
            <Link
              to="/pricing"
              className="py-2 text-gray-700 hover:text-gray-600 border-b border-gray-100"
              onClick={() => setToggleMenu(false)}
            >
              Pricing
            </Link>
            <Link
              to="/contact"
              className="py-2 text-gray-700 hover:text-gray-600 border-b border-gray-100"
              onClick={() => setToggleMenu(false)}
            >
              Contact
            </Link>
            {!hideAuthButtons && (
              <div className="pt-2 flex flex-col space-y-3">
                {!isAuthenticated ? (
                  <>
                    <Link
                      to="/login"
                      className="w-full text-center py-2 px-4 text-gray-700 hover:text-gray-600"
                      onClick={() => setToggleMenu(false)}
                    >
                      Sign In
                    </Link>
                    <Link
                      to="/register"
                      className="w-full text-center py-2 px-4 text-white bg-gray-600 rounded-full hover:bg-gray-700 active:bg-gray-800 transition-colors"
                      onClick={() => setToggleMenu(false)}
                    >
                      Try for Free
                    </Link>
                  </>
                ) : (
                  <Link
                    to="/app/dashboard"
                    className="w-full text-center py-2 px-4 text-white bg-gray-600 rounded-full hover:bg-gray-700"
                    onClick={() => setToggleMenu(false)}
                  >
                    Return to Dashboard
                  </Link>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </nav>
    </>
  );
};

export default Navbar;
